import {Button, Col, Row} from "reactstrap";
import Link from "next/link";
import React from "react";
import moment from "moment";
import AddCamperToCartButtonMobile from "../../Button/AddCamperToCartButtonMobile";
import {SearchSelection} from "../../../types/camper/searchSelection";

interface BookingButtonsProps {
    searchSelection: SearchSelection,
    encodedBookingDetails: string,
    price: number,
    camperBasePrice: number,
    camperSeoId: string
    selectedInsurance: any
    selectedOptions: any
    camperInfo: any
}

const encodeBookingDetails = (details) => {
    return Buffer.from(JSON.stringify(details)).toString("base64");
};

const AddToCartButton = React.forwardRef((props: any, ref) => (
    <AddCamperToCartButtonMobile {...props} />
));

const BookingButtons = ({
                            searchSelection,
                            encodedBookingDetails,
                            price,
                            camperSeoId,
                            selectedInsurance,
                            selectedOptions,
                            camperInfo,
                            camperBasePrice
                        }: BookingButtonsProps) => {
    const {pickupDate, dropOffDate} = searchSelection;

    return (
        <>
            <Row className="mb-2">
                <Col>
                    <strong className="text-sm">
                        {moment(pickupDate).format('DD MMM')} - {moment(dropOffDate).format('DD MMM Y')} voor
                    </strong>
                    <strong>
                        {" "}
                        € {price},-
                    </strong>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Link
                        href={`/camper/boeken/[details]`}
                        as={`/camper/boeken/${encodedBookingDetails}`}
                        passHref
                    >
                        <AddToCartButton
                            camperSeoId={camperSeoId}
                            pickupDate={searchSelection.pickupDate}
                            dropOffDate={searchSelection.dropOffDate}
                            pickupLocation={searchSelection.pickupLocation}
                            dropOffLocation={searchSelection.dropOffLocation}
                            insuranceOptions={JSON.stringify(selectedInsurance)}
                            options={JSON.stringify(selectedOptions)}
                        />
                    </Link>

                </Col>
                {/*<Col>*/}
                {/*    <Link*/}
                {/*        href={`/camper/boeken/[details]`}*/}
                {/*        as={`/camper/boeken/${encodeBookingDetails({*/}
                {/*            camper: camperInfo ? camperInfo.type : '',*/}
                {/*            startDate: searchSelection.pickupDate.format('YYYY-MM-DD'),*/}
                {/*            endDate: searchSelection.dropOffDate.format('YYYY-MM-DD'),*/}
                {/*            thumbnail: camperInfo ? camperInfo.images[0] : '',*/}
                {/*            optionalFees: selectedOptions,*/}
                {/*            insurance: selectedInsurance,*/}
                {/*            camperBasePrice: camperBasePrice,*/}
                {/*            tripLength: searchSelection.getTripLengthInDays(),*/}
                {/*            totalPrice: price*/}
                {/*        })}`}*/}
                {/*        passHref*/}
                {/*    >*/}
                {/*        <Button*/}
                {/*            size="sm"*/}
                {/*            aria-label="Boek cottage"*/}
                {/*            className="book-button"*/}
                {/*            color="primary"*/}
                {/*            block*/}
                {/*        >*/}
                {/*            Reserveren*/}
                {/*        </Button>*/}
                {/*    </Link>*/}

                {/*</Col>*/}
            </Row>
        </>
    );
}

export default BookingButtons;
